import React from "react";
import bonus_img from "../assets/features/feature_bonus_buy.png";
import double_img from "../assets/features/feature_double_chance.png";
import switch_img from "../assets/features/switch.png";
import { GameConfigs } from "../../lib/globals/GameConfigs";
import {
  formatCurrencyValue,
  getCurrencySymbol,
} from "../../controllers/helper/currencies";
export default function Features({
  currency,
  text,
  config,
  currentBet,
  currAbr,
}) {
  const current = config.double_steps[config.bet_steps.indexOf(currentBet)];
  console.log({ currency });
  return (
    <div className="additional_symbol_wrapper">
      <div className="title" style={{ margin: "auto" }}>
        {text[0].title}
      </div>
      <div className="features_wrapper">
        <div className="features_box">
          <div className="description">{text[0].double_desc_1}</div>
          <div className="feature_icon">
            <img src={double_img} alt="feature" className="background_img" />
            <img src={switch_img} alt="feature" className="switch" />
            <span className="amount">
              {formatCurrencyValue(current, getCurrencySymbol(currAbr, true))}
            </span>
            <span className="text">
              Double Chance <br /> to win <span className="green">feature</span>
            </span>
          </div>
          <div className="description">
            {text[0].double_desc_2} {GameConfigs.config.doublefeatureprice}%
          </div>
        </div>
        <div className="features_box">
          <div className="description">{text[0].bonus_desc_1}</div>
          <div className="bonus_icon">
            <img src={bonus_img} alt="feature" className="background_img" />
            <span className="bonus_text">BUY BONUS ({currAbr})</span>
            <span className="bonus_amount">
              {formatCurrencyValue(
                currentBet * GameConfigs.config.buyfeatureprice,
                currency,
                0,
                true
              )}
            </span>
          </div>
          <div className="description">
            {text[0].bonus_desc_2}{" "}
            {(+GameConfigs.config.buyfeatureprice).toFixed(0)}x{" "}
            {text[0].bonus_desc_3}
          </div>
        </div>
      </div>
    </div>
  );
}
